export { default } from './AboutUsPage';
